module.exports = __webpack_public_path__ + "img/tu2.c3ea53ea.png";